export type AdvanceButtonProps = {
  isPending: boolean;
  onAdvance: () => void;
};

export function AdvanceButton({ isPending, onAdvance }: AdvanceButtonProps): JSX.Element {
  return (
    <button
      type="button"
      disabled={isPending}
      onClick={onAdvance}
      className="w-full md:w-auto px-6 py-3 bg-reader-brand hover:bg-reader-brand-hover text-white font-semibold rounded disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-reader-focus-ring focus-visible:ring-offset-2 focus-visible:ring-offset-reader-page active:scale-[0.98] transition-transform"
    >
      次へ進む
    </button>
  );
}
